import Link from 'next/link';

export default function UpgradeBanner() {
  return (
    <div className='mx-6 mt-3 py-3 px-3 bg-content3 rounded-lg'>
      <div className='flex items-center gap-2'>
        <h4 className='text-sm font-medium leading-5'>Upgrade to Starter</h4>
      </div>
      <p className='text-xs text-default-700 my-1.5'>Unlock more participants and enable branding.</p>
      <Link href='/pricing' className='text-blue-600 text-sm font-semibold'>View plans</Link>
    </div>
  );
}
